import * as React from 'react'
// libs
import { Helmet } from 'react-helmet'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
// components
import Home from './views/Home'
import HomeEU from './views/HomeEU'
import PrivacyPolicyEU from './views/PrivacyPolicyEU'
import WorkforceCapabilityIntelligence from './views/WorkforceCapabilityIntelligence'
import Contact from './views/Contact'
import Customer from './views/Customer'
import CareerConnector from './views/CareerConnector'
import LearningManagement from './views/LearningManagement'
import WalmartMilitaryCareers from './views/WalmartMilitary'
import NsfOhioProject from './views/NsfOhioProject'
import NsfSkillsMapping from './views/NsfSkillsMapping'
import Enterprise from './views/Enterprise'
import Staffing from './views/Staffing'
import RPO from './views/RPO'
import Agencies from './views/Agencies'
import MWM from './views/MWM'
import Team from './views/Team'
import Alumni from './views/Alumni'
import Recruiting from './views/Recruiting'
import SkillBridge from './views/SkillBridge'
import PlatformArchitecture from './views/PlatformArchitecture'
import CulturalCollectionsDigital from './views/CulturalCollectionsDigital'
import ScrollHandler from './components/layouts/ScrollHandler'
import RouterTracker from './components/RouterTracker'
import { initGA } from './utils/analytics'
// styles
import './styles/global.css'

function App() {
  const isPod = ['podglobal.com'].includes(window.location.hostname)
  const isWalmart =
    window.location.hostname === 'walmartmilitarycareers.podglobal.com'
  const isAlumni = ['podalumni.com', 'www.podalumni.com'].includes(
    window.location.hostname
  )
  const isPodEU = ['podeurope.uk', 'www.podeurope.uk'].includes(
    window.location.hostname
  )

  let GA_ID = null

  if (isPodEU) {
    GA_ID = 'G-8RLSVFLX2M'
  } else if (!isAlumni && !isWalmart) {
    GA_ID = 'G-8XKTB7X9KM'
  }

  React.useEffect(() => {
    if (GA_ID) {
      initGA(GA_ID)
    }
  }, [GA_ID])

  const mainLanding = React.useMemo(() => {
    if (isAlumni) {
      return <Alumni />
    }

    if (isPodEU) {
      return <HomeEU />
    }

    return <Home />
  }, [isAlumni, isPodEU])

  return (
    <BrowserRouter>
      <RouterTracker measurementId={GA_ID} />
      <Helmet>
        <title>POD Global</title>
        <meta
          name='description'
          content="Pod's Talent Intelligence platform is a comprehensive solution designed to future-proof workforces by providing corporations and organizations with actionable insights into their talent landscape."
        />
        <meta property='og:title' content='POD Global' />
        <meta
          property='og:description'
          content="Pod's Talent Intelligence platform is a comprehensive solution designed to future-proof workforces by providing corporations and organizations with actionable insights into their talent landscape."
        />
      </Helmet>
      <ScrollHandler />
      {isPod ? (
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/skillbridge' element={<SkillBridge />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/customer' element={<Customer />} />
          <Route path='/career-connector' element={<CareerConnector />} />
          <Route path='/learning-management' element={<LearningManagement />} />
          <Route path='/nsfohioproject' element={<NsfOhioProject />} />
          <Route path='/research' element={<NsfSkillsMapping />} />
          <Route path='/million-women-mentors-afghanistan' element={<MWM />} />
          <Route path='/enterprise' element={<Enterprise />} />
          <Route path='/staffing' element={<Staffing />} />
          <Route path='/rpo' element={<RPO />} />
          <Route path='/agencies' element={<Agencies />} />
          <Route path='/team' element={<Team />} />
          <Route path='/recruiting' element={<Recruiting />} />
          <Route
            path='/platform-architecture'
            element={<PlatformArchitecture />}
          />
          <Route
            path='/cultural-collections-digital'
            element={<CulturalCollectionsDigital />}
          />
        </Routes>
      ) : isWalmart ? (
        <Routes>
          <Route path='/' element={<WalmartMilitaryCareers />} />
          <Route path='/skillbridge' element={<SkillBridge />} />          
        </Routes>
      ) : (
        <Routes>
          <Route path='/' element={mainLanding} />
          <Route path='/skillbridge' element={<SkillBridge />} />
          <Route path='/privacy-policy-uk' element={<PrivacyPolicyEU />} />
          <Route
            path='/workforce-capability-intelligence'
            element={<WorkforceCapabilityIntelligence />}
          />
          <Route path='/contact' element={<Contact isEu />} />
          <Route path='/customer' element={<Customer />} />
          <Route path='/career-connector' element={<CareerConnector />} />
          <Route path='/learning-management' element={<LearningManagement />} />
          <Route path='/nsfohioproject' element={<NsfOhioProject />} />
          <Route path='/research' element={<NsfSkillsMapping />} />
          <Route
            path='/walmart-military-careers'
            element={<WalmartMilitaryCareers />}
          />
          <Route path='/million-women-mentors-afghanistan' element={<MWM />} />
          <Route path='/enterprise' element={<Enterprise />} />
          <Route path='/staffing' element={<Staffing />} />
          <Route path='/rpo' element={<RPO />} />
          <Route path='/agencies' element={<Agencies />} />
          <Route path='/team' element={<Team />} />
          <Route path='/recruiting' element={<Recruiting />} />
          <Route
            path='/platform-architecture'
            element={<PlatformArchitecture />}
          />
          <Route
            path='/cultural-collections-digital'
            element={<CulturalCollectionsDigital />}
          />
        </Routes>
      )}
    </BrowserRouter>
  )
}

export default App
